import { createContext } from 'react'

import { ID } from '@s4l/stayforlong/kernel/ID'
import { ListOfAvailability } from '@s4l/stayforlong/booking/ListOfAvailability'

interface RoomConfiguratorContextType {
  roomID: ID
  listOfAvailability: ListOfAvailability
  isMultiBooking: boolean
}

export const RoomConfiguratorContext = createContext<RoomConfiguratorContextType>({
  listOfAvailability: ListOfAvailability.empty(),
  roomID: ID.create({ value: '' }),
  isMultiBooking: false,
})
